import DataCacheRepository from '../../analytics/src/datalayer/data-cache-repository';
import SubscriptionSource from './helpers/piano-subscription-source';
import DatalayerUsrSegment from '../../analytics/src/datalayer/datalayer-usr-segment';
import manageSubscriptionLink from './helpers/manage-subscription-link';

export default function UserEntitlements ( dataLayer, consent ) {
	this.dataLayer = dataLayer || window.dataLayer || [];
	this.consent = consent;
	this.subscriptionSource = new SubscriptionSource();
	this.subscriptionSource.init();
}

const siteUrl = new URL( window.NS_SITEURL );

UserEntitlements.constructor = UserEntitlements;
UserEntitlements.USER_ENTITLEMENT_ENDPOINT = '/wp-json/ns-subscribers/v1/user-entitlements';
UserEntitlements.METHOD = 'GET';
UserEntitlements.LOGOUT_COOKIE_REGEX = /logout-cookie=1/;
UserEntitlements.BANNER_DISMISS_KEY = 'register-interest-banner-dismissed';
UserEntitlements.BANNER_DISMISS_TIMEOUT = 2592000000; // 30 days

UserEntitlements.prototype.buildUserContext = async function ( makeFreshCall ) {
	makeFreshCall = makeFreshCall ? makeFreshCall : false;
	let userDataSet = false;

	if ( ! makeFreshCall ) {
		const userData = DataCacheRepository.getItem(
			DataCacheRepository.KEY_USER_DATA,
		);
		if ( userData ) {
			this.user_context_callbacks.forEach(
				function ( callback ) {
					callback.call( this, userData.data );
				}.bind( this ),
			);
			userDataSet = true;
		}
	}

	if ( siteUrl.hostname === window.location.hostname ) { // phpcs:ignore WordPressVIPMinimum.JS.Window.location
		if ( ! userDataSet ) {
			try {
				const response = await fetch(
					UserEntitlements.USER_ENTITLEMENT_ENDPOINT,
					{
						method: UserEntitlements.METHOD,
						credentials: 'same-origin',
						headers: { Accept: 'application/json' },
					},
				);

				if ( ! response.ok ) {
					throw new Error( `Response status: ${response.status}` );
				}

				const data = await response.json();
				this.handleUserDataStateChange( data );
			} catch ( error ) {
				console.error( 'Error fetching user entitlements. ', error ); // eslint-disable-line no-console
				this.subscriptionSource.showFallback();
			}
		}
	}
};

UserEntitlements.prototype.handleUserDataStateChange = function ( data ) {
	const payload = typeof data === 'string' ? data : JSON.stringify( data );

	this.user_context_callbacks.forEach(
		function ( callback ) {
			callback.call( this, payload );
		}.bind( this ),
	);

	DataCacheRepository.setItem(
		data,
		DataCacheRepository.KEY_USER_DATA,
		DataCacheRepository.TTL_USER_DATA,
	);
};

UserEntitlements.prototype.user_context_callbacks = [
	function trackUser ( response ) {
		let data;
		try {
			data = JSON.parse( response );
		} catch ( error ) {
			this.subscriptionSource.showFallback();
			return;
		}
		const userDTO = {};

		this.subscriptionSource.setSubscriptionOrigin( data.origin );
		manageSubscriptionLink();

		if ( data.partyId ) {
			userDTO.id = data.partyId;

			if ( data.productType ) {
				userDTO.subscription_package = data.productType;
			}
		}

		window.tp = window.tp || [];
		window.tp.push( [ 'init', function () {
			if ( window.tp.pianoId && window.tp.pianoId.isUserValid() ) {
				// User is logged in
				const datalayerUsrSegment = new DatalayerUsrSegment();
				datalayerUsrSegment.init();
			}
		} ] );
	},
];
